
const LOCALE_KEY = 'pr_locale'
let selectedLocale = null;

const getStoredLocale = () => {
  const storedLocale = localStorage.getItem(LOCALE_KEY);
  if (storedLocale && ['sv-SE', 'en-US'].includes(storedLocale)) {
    return storedLocale;
  }
  return null;
}

const browserLocale = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const isSwedish = browserLang === 'sv-SE' || browserLang === 'sv';
  return isSwedish ? 'sv-SE' : 'en-US';

  // Fram tills vi har all språkstöd på plats så kör vi bara på svenska
  // return 'sv-SE';
}


export const setLocale = (locale) => {
  selectedLocale = locale;
  localStorage.setItem(LOCALE_KEY, locale);
}

export const getLocale = () => {
  return selectedLocale || getStoredLocale() || browserLocale();
}

export const isSwedishLocale = () => getLocale() === 'sv-SE'

const pickTextByProperty = (item, propertyName, defaultText) => {
  const property = isSwedishLocale() ? propertyName : `${propertyName}_eng`;
  return item && item[property] ? item[property] : defaultText;
}

export const pickLocaleText = (item, defaultText = '') => pickTextByProperty(item, 'text', defaultText);

export const pickLocaleDescription = (item, defaultText = '') => pickTextByProperty(item, 'description', defaultText);

export const pickLocaleName = (item, defaultText = '') => pickTextByProperty(item, 'name', defaultText);

export const pickLocaleNameWithFallback = (item) => {
  const sweText = item['name'];
  const engText = item['name_eng'];

  if (isSwedishLocale() && sweText) {
    return sweText;
  }

  if (engText) {
    return engText;
  }

  return sweText || '';
};
